var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "m20.6 12.2-.1-1.8H12v3.4h4.8C16.6 15 16 16 15 16.6v2.2h3a8.8 8.8 0 0 0 2.6-6.6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M12 21c2.4 0 4.5-.8 6-2.2l-3-2.2a5.4 5.4 0 0 1-8-2.9H4V16a9 9 0 0 0 8 5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M7 13.7a5.4 5.4 0 0 1 0-3.4V8H4a9 9 0 0 0 0 8z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M12 6.6c1.3 0 2.5.4 3.4 1.3L18 5.3A9 9 0 0 0 4 8l3 2.4a5.4 5.4 0 0 1 5-3.7Z",
    clipRule: "evenodd"
  })));
};
export { SvgGoogle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0yMC42IDEyLjItLjEtMS44SDEydjMuNGg0LjhDMTYuNiAxNSAxNiAxNiAxNSAxNi42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNloiIGZpbGw9IiM0Mjg1RjQiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDIxYzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUg0VjE2YTkgOSAwIDAgMCA4IDVaIiBmaWxsPSIjMzRBODUzIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDEzLjdhNS40IDUuNCAwIDAgMSAwLTMuNFY4SDRhOSA5IDAgMCAwIDAgOGwzLTIuM1oiIGZpbGw9IiNGQkJDMDUiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDYuNmMxLjMgMCAyLjUuNCAzLjQgMS4zTDE4IDUuM0E5IDkgMCAwIDAgNCA4bDMgMi40YTUuNCA1LjQgMCAwIDEgNS0zLjdaIiBmaWxsPSIjRUE0MzM1Ii8+PC9zdmc+Cg==";